// extracted by mini-css-extract-plugin
module.exports = {"test--header":"test--header__2x5Ne","header--left":"header--left__TwYXb","back--logo":"back--logo__1_dnQ"};